import { useEffect, useState } from "react";
import { fetchPageContent } from "../api/contentApi";
import { useLang } from "../context/LangContext";
import bgImg from "../assets/career_bg.jpg";
import careerImage from "../assets/career.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEnvelope, faPhone} from "@fortawesome/free-solid-svg-icons";
import "../styles/career.css";

export default function Career() {
  const [content, setContent] = useState({});
  const { lang } = useLang();

  useEffect(() => {
    fetchPageContent("career", lang).then(data => setContent(data));
  }, [lang]);

    const lookingFor = [
    content.looking,
    content.looking_1,
    content.looking_2,
    content.looking_3,
    content.looking_4,
    content.looking_5,
  ].filter(Boolean);

   const offer = [
    content.offer,
    content.offer_1,
    content.offer_2,
    content.offer_3,
    content.offer_4,
    content.offer_5,
  ].filter(Boolean);

  if (!content) return <p>Loading...</p>;
  return (
  <section className="career-page">
      <div className="career-bg"
        style={{ backgroundImage: `url(${bgImg})` }}>
      <div className="career-overlay">
        {content.career_title && ( 
      <h1 className="career-title">{content.career_title}</h1>
        )}
        {content.career_main && ( 
      <h2 className="career-intro">
        {content.career_main}
      </h2>
        )}

      
<div className="about-intro">
      
         {content.career_text_1 && ( 
        <p>{content.career_text_1}</p>
        )}
        {content.career_text_2 && ( 
        <p>{content.career_text_2}</p>
        )}
       
      </div>

    <div className="career-lists-row">

      {/* Looking for List */}
     <div className="looking-for-section">
      <h2 className="looking-for-title">
        {content.looking_title_1}
        </h2>
       <div className="looking-for-list">
        {lookingFor.map((looking, idx) => (
          <div key={idx} className="looking-for-item">
            ✔ {looking}
          </div>
        ))}
      </div>
      </div>

        {/* Offer List */}
     <div className="offer-section">
      <h2 className="offer-title">
        {content.offer_title_1}
        </h2>
       <div className="offer-list">
        {offer.map((offer, idx) => (
          <div key={idx} className="offer-item">
            ✔ {offer}
          </div>
        ))}
      </div>
      </div>
        </div>

<div className="career-closing-section">

          {/* Img */}
        <div className="career-image">
    <img
      src={careerImage}
      alt="Ship hull construction"
    />
    </div>
  <div className="career-closing-text">
        {content.career_text_3 && ( 
        <p>{content.career_text_3}</p>
        )}
        {content.career_text_4 && ( 
        <p>{content.career_text_4}</p>
        )}

        {content.career_email && (
              <a href={`mailto:${content.career_email}`} className="footer-email">
                <FontAwesomeIcon icon={faEnvelope} /> {content.career_email}
              </a>
            )}
        {content.career_phone && (
         
          <div>
         <a className="career-contact" href={`tel:+${content.career_phone}`}>
            <FontAwesomeIcon icon={faPhone} /> + {content.career_phone}
          </a>
          </div>
        )}
        </div>
         </div>
       <div className="spacer"/>
       </div>
       </div>
    </section>

  );

};